import type { Translations } from './types'

export const es: Translations = {
  header: {
    login: 'Iniciar sesion',
    logout: 'Cerrar sesion',
    myAccount: 'Mi cuenta',
  },

  nav: {
    edit: 'Editar',
    myCVs: 'Mis CVs',
    preview: 'Preview',
    import: 'Importar',
  },

  editor: {
    title: 'Editar CV',
    autoSaved: 'Autoguardado',
    saving: 'Guardando...',
    saved: 'Guardado',
    completeness: 'Completitud del CV',
    alreadyAutoSaved: 'Ya se guarda automaticamente',
  },

  sections: {
    photo: 'Foto del CV',
    personalInfo: 'Informacion Personal',
    links: 'Enlaces',
    summary: 'Resumen',
    experience: 'Experiencia',
    education: 'Educacion',
    skills: 'Habilidades',
    languages: 'Idiomas',
    settings: 'Configuracion',
  },

  personalInfoForm: {
    fullName: 'Nombre completo',
    fullNamePlaceholder: 'Tu nombre completo',
    professionalTitle: 'Titulo profesional',
    professionalTitlePlaceholder: 'ej. Ingeniero de Software',
    email: 'Email',
    emailPlaceholder: 'tu@email.com',
    phone: 'Telefono',
    phonePlaceholder: '+34 612 345 678',
    location: 'Ubicacion',
    locationPlaceholder: 'Ciudad, Pais',
    birthDate: 'Fecha de nacimiento',
    birthDateHelper: 'Formato: YYYY-MM-DD',
  },

  linksForm: {
    label: 'Etiqueta',
    labelPlaceholder: 'ej. LinkedIn, GitHub, Portfolio',
    url: 'URL',
    urlPlaceholder: 'https://...',
    add: '+ Agregar',
    empty: 'Agrega enlaces a LinkedIn, GitHub, portafolio, etc.',
    addFirst: '+ Agregar primer enlace',
    noLinks: 'No hay enlaces agregados',
    invalidUrl: 'URL invalida',
  },

  summaryForm: {
    label: 'Resumen profesional',
    placeholder: 'Profesional con X anos de experiencia en... Especializado en... Busco oportunidades en...',
    hint: 'Un breve parrafo que destaque tu experiencia, habilidades y objetivos profesionales.',
    improve: 'Mejorar con IA',
  },

  experienceForm: {
    company: 'Empresa',
    companyPlaceholder: 'Nombre de la empresa',
    position: 'Puesto',
    positionPlaceholder: 'Tu cargo o titulo',
    location: 'Ubicacion',
    locationPlaceholder: 'Ciudad, Pais',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currentJob: 'Trabajo actual',
    description: 'Descripcion',
    descriptionPlaceholder: 'Describe tus responsabilidades y logros principales...',
    delete: 'Eliminar experiencia',
    add: '+ Agregar experiencia',
    empty: 'Agrega tu experiencia laboral, empezando por la mas reciente.',
    itemTitle: 'Experiencia',
  },

  educationForm: {
    institution: 'Institucion',
    institutionPlaceholder: 'Universidad o centro educativo',
    degree: 'Titulo',
    degreePlaceholder: 'Grado, Licenciatura, Master...',
    field: 'Campo de estudio',
    fieldPlaceholder: 'Informatica, Administracion...',
    location: 'Ubicacion',
    locationPlaceholder: 'Ciudad, Pais',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currentlyStudying: 'Cursando actualmente',
    gpa: 'Promedio / GPA (opcional)',
    gpaPlaceholder: '8.5 / 10',
    delete: 'Eliminar educacion',
    add: '+ Agregar educacion',
    empty: 'Agrega tu formacion academica, empezando por la mas reciente.',
    itemTitle: 'Educacion',
  },

  skillsForm: {
    technical: 'Habilidades tecnicas',
    technicalPlaceholder: 'ej. React, TypeScript, Node.js',
    soft: 'Habilidades blandas',
    softPlaceholder: 'ej. Liderazgo, Comunicacion',
    tools: 'Herramientas',
    toolsPlaceholder: 'ej. VS Code, Figma, Docker',
    addHint: 'Presiona Enter para agregar',
    add: 'Agregar',
    removeAria: 'Eliminar',
  },

  languagesForm: {
    name: 'Idioma',
    namePlaceholder: 'ej. Ingles',
    level: 'Nivel',
    delete: 'Eliminar',
    add: '+ Agregar idioma',
    selectLevel: 'Selecciona un nivel',
    empty: 'Agrega los idiomas que dominas y tu nivel de competencia.',
    itemTitle: 'Idioma',
    levels: {
      native: 'Nativo',
      fluent: 'Fluido',
      advanced: 'Avanzado',
      intermediate: 'Intermedio',
      basic: 'Basico',
    },
  },

  settingsForm: {
    dateFormat: 'Formato de fechas',
    dateFormatDesc: 'Elige como se muestran las fechas en tu CV',
    monthYear: 'Mes y Ano',
    yearOnly: 'Solo Ano',
    cvLanguage: 'Idioma del CV',
    cvLanguageDesc: 'Idioma para las etiquetas (Experiencia, Educacion, etc.)',
    contactIcons: 'Iconos de contacto',
    contactIconsDesc: 'Mostrar iconos junto a email, telefono y ubicacion',
    cvLabelHint: 'Etiqueta en CV',
  },

  photoForm: {
    upload: 'Subir foto',
    dragDrop: 'Arrastra una foto o haz clic para seleccionar',
    maxSize: 'JPG, PNG o WebP (max 8MB)',
    remove: 'Eliminar foto',
    photoLoaded: 'Foto cargada',
    changeHint: 'Haz clic en la X para cambiar la foto',
    processing: 'Procesando imagen...',
    dropHere: 'Suelta la imagen aqui',
    validationError: 'Error al validar la imagen',
    processError: 'Error al procesar la imagen',
    templateHint: 'La foto aparecera en tu CV segun el template seleccionado. Es opcional.',
  },

  previewPane: {
    title: 'Vista previa',
    subtitle: 'Asi se vera tu CV',
    template: 'Plantilla',
    chooseTemplate: 'Elige un template',
    download: 'Descargar',
    share: 'Compartir',
  },

  cvList: {
    title: 'Mis CVs',
    newCV: '+ Nuevo CV',
    new: 'Nuevo',
    rename: 'Renombrar CV',
    delete: 'Eliminar CV',
    deleteConfirm: '¿Eliminar este CV?',
    noTitle: 'Sin titulo',
    now: 'Ahora',
    minutesAgo: 'Hace {n}m',
    hoursAgo: 'Hace {n}h',
    daysAgo: 'Hace {n}d',
    importBtn: 'Importar PDF',
    import: 'Importar',
    expand: 'Expandir panel',
    collapse: 'Colapsar panel',
    empty: 'No tienes CVs guardados',
    emptySubtitle: 'Crea uno nuevo o importa un PDF',
    saved: 'CV guardado',
    savedPlural: 'CVs guardados',
    newCVDefault: 'Mi CV',
  },

  import: {
    title: 'Importar CV desde PDF',
    subtitle: 'Sube tu CV existente y lo convertiremos en un formato editable',
    dragDrop: 'Arrastra un PDF aqui o haz clic para seleccionar',
    maxFileSize: 'Maximo 10MB',
    analyzing: 'Analizando con IA...',
    review: 'Revisar datos extraidos',
    reviewTitle: 'Datos extraidos',
    importBtn: 'Importar',
    cancel: 'Cancelar',
    readingPdf: 'Leyendo el archivo PDF...',
    extractingText: 'Extrayendo texto del documento...',
    analyzingAI: 'Analizando con inteligencia artificial...',
    finishing: 'Finalizando...',
    completed: 'Completado',
    tipsTitle: 'Consejos para mejores resultados',
    tipSelectable: 'Usa PDFs con texto seleccionable (no escaneados)',
    tipStandard: 'Formatos estandar de CV funcionan mejor',
    tipEditable: 'Podras editar los datos despues de importar',
    errorTitle: 'Error al procesar el PDF',
    importedTitle: 'CV Importado',
    importedSuccess: 'CV importado correctamente',
    mayTakeSeconds: 'Esto puede tomar unos segundos',
    stepReading: 'Leyendo PDF',
    stepExtracting: 'Extrayendo texto',
    stepAnalyzing: 'Analizando con IA',
    stepDone: 'Listo',
    invalidFile: 'Archivo invalido',
    noTextExtracted: 'No se pudo extraer texto del PDF. Esto puede ocurrir si el PDF es una imagen escaneada o tiene el texto protegido. Intenta con un PDF que tenga texto seleccionable.',
    invalidFileType: 'Archivo no valido',
    onlyPdf: 'Solo se permiten archivos PDF',
    dropHere: 'Suelta el archivo aqui',
    dropToImport: 'Soltarlo para comenzar la importacion',
    dragOrClick: 'Arrastra tu CV aqui o haz clic para seleccionar',
    tapToSelect: 'Toca para seleccionar tu CV',
    pdfUpTo: 'Archivos PDF hasta 10MB',
    fileMustBePdf: 'El archivo debe ser un PDF',
    fileTooLarge: 'El archivo es demasiado grande. Maximo',
    fileMustBeAudio: 'El archivo debe ser un archivo de audio valido (MP3, WAV, WebM, M4A)',
    invalidEmail: 'El email no es valido',
    invalidUrl: 'La URL no es valida',
    invalidPhone: 'El telefono no es valido',
  },

  welcome: {
    title: 'Crea tu CV profesional en minutos',
    subtitle: 'Elige como quieres empezar',
    createFromScratch: 'Crear desde cero',
    scratchDesc: 'Empieza con un CV en blanco y completalo paso a paso',
    importPdf: 'Importar PDF',
    importDesc: 'Sube tu CV existente y editalo con nuestras herramientas',
    voiceCreate: 'Crear con voz',
    voiceDesc: 'Dicta tu experiencia y generaremos tu CV automaticamente',
    voiceComingSoon: 'Proximamente',
  },

  aiReview: {
    reviewCV: 'Revisar CV',
    reviewing: 'Revisando...',
    score: 'Puntuacion',
    strengths: 'Fortalezas',
    improvements: 'Areas de mejora',
    applySuggestion: 'Aplicar correccion',
    applied: 'Aplicado',
    copied: 'Copiado',
    loginToReview: 'Inicia sesion para revisar tu CV con IA',
    addContentFirst: 'Agrega contenido a tu CV antes de revisarlo',
    reviewWithAITitle: 'Revisar CV con IA',
    loginToReviewTitle: 'Inicia sesion para revisar tu CV',
    aiWillAnalyze: 'La IA analizara tu CV y te dara sugerencias para mejorarlo.',
    reviewNow: 'Revisar ahora',
    reviewTitle: 'Revision de tu CV',
    scoreLabel: 'Puntuacion',
    excellent: 'Excelente',
    good: 'Bueno',
    needsImprovement: 'Necesita mejoras',
    needsAttention: 'Requiere atencion',
    detailedRecommendations: 'Recomendaciones detalladas',
    suggestion: 'Sugerencia:',
    copiedPaste: 'Copiado - pegalo en el formulario',
    applyFix: 'Aplicar correccion',
    close: 'Cerrar',
    sectionPersonal: 'Informacion Personal',
    sectionSummary: 'Resumen',
    sectionExperience: 'Experiencia',
    sectionEducation: 'Educacion',
    sectionSkills: 'Habilidades',
    sectionLanguages: 'Idiomas',
    sectionGeneral: 'General',
    loginToUseAI: 'Debes iniciar sesion para usar la IA',
    noTextToImprove: 'No hay texto para mejorar',
    suggestionError: 'Error al obtener sugerencias',
    rateLimitReached: 'Has alcanzado el limite de revisiones',
    reviewProcessError: 'Error al procesar la revision. Intenta de nuevo.',
    unknownReviewError: 'Error desconocido al revisar el CV',
  },

  aiSuggestion: {
    title: 'Sugerencia de IA',
    reviewImproved: 'Revisa la version mejorada de tu texto',
    original: 'Original',
    improved: 'Mejorado',
    additionalSuggestions: 'Sugerencias adicionales',
    useImproved: 'Usar texto mejorado',
  },

  auth: {
    login: 'Iniciar sesion',
    register: 'Crear cuenta',
    email: 'Email',
    emailPlaceholder: 'tu@email.com',
    password: 'Contrasena',
    passwordPlaceholder: '••••••••',
    confirmPassword: 'Confirmar contrasena',
    confirmPasswordPlaceholder: 'Repite tu contrasena',
    fullName: 'Nombre completo',
    fullNamePlaceholder: 'Juan Perez',
    forgotPassword: '¿Olvidaste tu contrasena?',
    forgotPasswordTitle: 'Recuperar contrasena',
    forgotPasswordSubtitle: 'Te enviaremos un email con instrucciones para restablecer tu contrasena',
    emailSentTitle: 'Email enviado',
    emailSentDescription: 'Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contrasena.',
    backToLogin: 'Volver al inicio de sesion',
    sendEmail: 'Enviar email',
    user: 'Usuario',
    orContinueWith: 'O continua con',
    orContinueEmail: 'o continua con email',
    orRegisterEmail: 'o registrate con email',
    google: 'Google',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    resetPassword: 'Restablecer contrasena',
    resetSent: 'Email de restablecimiento enviado',
    welcomeBack: 'Bienvenido de vuelta',
    loginSubtitle: 'Inicia sesion para acceder a tus CVs',
    registerTitle: 'Crea tu cuenta',
    registerSubtitle: 'Guarda tus CVs en la nube y accede desde cualquier dispositivo',
    signUpFree: 'Registrate gratis',
    emailRequired: 'El email es requerido',
    passwordRequired: 'La contrasena es requerida',
    nameRequired: 'El nombre es requerido',
    passwordMinLength: 'La contrasena debe tener al menos 6 caracteres',
    passwordMismatch: 'Las contrasenas no coinciden',
    signOut: 'Cerrar sesion',
  },

  shortcuts: {
    title: 'Atajos de teclado',
    subtitle: 'Navega mas rapido',
    undo: 'Deshacer',
    redo: 'Rehacer',
    save: 'Guardar (ya autoguardado)',
    downloadPdf: 'Descargar PDF',
    showShortcuts: 'Mostrar atajos',
  },

  common: {
    close: 'Cerrar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    loading: 'Cargando...',
    error: 'Error',
    retry: 'Reintentar',
    copied: 'Copiado al portapapeles',
  },

  emptyState: {
    title: 'Tu CV aparecera aqui',
    subtitle: 'Comienza a llenar el formulario',
  },

  cvListFull: {
    localCVTitle: 'Tienes un CV guardado localmente',
    anonymousTitle: 'Aun no has importado ningun CV',
    noCVsTitle: 'No tienes CVs todavia',
    localCVDesc: 'Parece que estuviste trabajando en un CV antes de crear tu cuenta. Quieres importarlo?',
    anonymousDesc: 'Importa tu CV desde un PDF o crea uno nuevo. Tus CVs se guardaran en este navegador.',
    noCVsDesc: 'Crea tu primer CV profesional en minutos. Es gratis y facil de usar.',
    importing: 'Importando...',
    importLocal: 'Importar CV local',
    importPdf: 'Importar PDF',
    createNew: 'Crear nuevo CV',
    importSuccess: 'CV importado correctamente',
    importError: 'Error al importar el CV',
    localFound: 'CV local encontrado',
    localFoundDesc: 'Tienes un CV guardado en este navegador que no esta sincronizado',
    deleteConfirm: 'Estas seguro de que quieres eliminar este CV?',
    defaultBadge: 'Predeterminado',
    edit: 'Editar',
    setDefault: 'Predeterminado',
    delete: 'Eliminar',
    expAbbr: 'exp.',
    eduAbbr: 'edu.',
    loadError: 'Error al cargar los CVs',
    cvDeleted: 'CV eliminado',
    cvSetDefault: 'CV establecido como predeterminado',
    deleteError: 'Error al eliminar el CV',
    setDefaultError: 'Error al establecer el CV predeterminado',
  },

  templates: {
    cleanDesc: 'Minimalista y profesional',
    boldDesc: 'Moderno y llamativo',
    creativeDesc: 'Colorido y visual',
    techDesc: 'Estilo developer',
    executiveDesc: 'Elegante y formal',
    modernDesc: 'Header a color completo',
    colors: 'Colores:',
  },

  completeness: {
    title: 'Completitud del CV',
    fullName: 'Nombre completo',
    professionalTitle: 'Titulo profesional',
    contactInfo: 'Datos de contacto',
    professionalSummary: 'Resumen profesional',
    workExperience: 'Experiencia laboral',
    education: 'Educacion',
    skills: 'Habilidades',
    languages: 'Idiomas',
  },

  notFound: {
    title: 'Pagina no encontrada',
    goToEditor: 'Ir al editor',
  },

  authErrors: {
    emailAlreadyInUse: 'Este email ya esta registrado',
    invalidEmail: 'Email invalido',
    operationNotAllowed: 'Operacion no permitida',
    weakPassword: 'La contrasena debe tener al menos 6 caracteres',
    userDisabled: 'Esta cuenta ha sido deshabilitada',
    userNotFound: 'No existe una cuenta con este email',
    wrongPassword: 'Contrasena incorrecta',
    invalidCredential: 'Credenciales invalidas',
    tooManyRequests: 'Demasiados intentos. Intenta mas tarde',
    popupClosed: 'Se cerro la ventana de inicio de sesion',
    authError: 'Error de autenticacion',
    unknownError: 'Error desconocido',
  },

  publicCV: {
    notExist: 'Este CV no existe o fue despublicado',
    createFree: 'Crear tu CV gratis',
    loadingCV: 'Cargando CV...',
    downloadPdf: 'Descargar PDF',
    createdWith: 'Creado con',
    createFreeMinutes: 'Crea tu CV gratis en minutos',
  },

  importReview: {
    processedSuccess: 'PDF procesado correctamente',
    reviewExtracted: 'Revisa los datos extraidos antes de continuar',
    analyzedWithAI: 'Analizado con IA',
    personalInfo: 'Informacion Personal',
    summary: 'Resumen',
    experience: 'Experiencia',
    education: 'Educacion',
    languages: 'Idiomas',
    more: 'mas',
    editableNote: 'Podras editar todos los datos despues de importar. La extraccion automatica puede no ser perfecta.',
    importAndEdit: 'Importar y editar',
  },

  landing: {
    nav: {
      features: 'Características',
      templates: 'Plantillas',
      howItWorks: 'Cómo funciona',
      startFree: 'Empezar gratis',
    },
    hero: {
      title: 'Tu próximo CV,',
      titleHighlight: 'en minutos.',
      subtitle: 'Crea un currículum profesional con IA, multiples plantillas y descarga en PDF. Sin registro.',
      cta: 'Crear mi CV gratis',
      ctaSecondary: 'Ver plantillas',
      badge: 'Empieza gratis',
    },
    features: {
      title: 'Todo lo que necesitas',
      subtitle: 'Herramientas profesionales para crear el CV perfecto',
      ai: 'Asistente con IA',
      aiDesc: 'Mejora tu resumen y recibe sugerencias inteligentes para cada sección de tu CV.',
      templates: 'Multiples plantillas profesionales',
      templatesDesc: 'Desde minimalista hasta creativo. Cada plantilla esta disenada para destacar, y seguimos anadiendo mas.',
      pdf: 'Descarga instantánea en PDF',
      pdfDesc: 'Exporta tu CV en PDF de alta calidad, listo para enviar a cualquier empresa.',
      free: 'Gratis para empezar',
      freeDesc: 'Crea, edita y descarga tu CV sin costo. Algunas plantillas premium disponibles para quienes quieran mas.',
      noSignup: 'Sin registro obligatorio',
      noSignupDesc: 'Empieza a crear tu CV inmediatamente. Regístrate solo si quieres guardar en la nube.',
      cloud: 'Guardado en la nube',
      cloudDesc: 'Crea una cuenta para sincronizar tus CVs y acceder desde cualquier dispositivo.',
    },
    templatesSection: {
      title: 'Plantillas para cada estilo',
      subtitle: 'Elige la que mejor se adapte a tu perfil profesional',
      clean: 'Clean',
      cleanDesc: 'Minimalista y profesional. Ideal para roles corporativos.',
      bold: 'Bold',
      boldDesc: 'Moderno con sidebar oscuro. Perfecto para destacar.',
      creative: 'Creative',
      creativeDesc: 'Colorido y visual. Ideal para roles creativos.',
      tech: 'Tech',
      techDesc: 'Estilo developer con monospace y terminal vibes.',
      executive: 'Executive',
      executiveDesc: 'Elegante y formal. Para cargos directivos.',
      modern: 'Modern',
      modernDesc: 'Header a color completo. Fresco y actual.',
    },
    howItWorks: {
      title: 'Tres pasos, un CV profesional',
      subtitle: 'Así de simple es crear tu currículum',
      step1Title: 'Completa tu información',
      step1Desc: 'Llena el formulario con tus datos, experiencia y habilidades. La IA te ayuda en el camino.',
      step2Title: 'Elige tu plantilla',
      step2Desc: 'Selecciona entre multiples disenos profesionales y personaliza colores al instante.',
      step3Title: 'Descarga y comparte',
      step3Desc: 'Exporta en PDF de alta calidad o comparte con un link público.',
    },
    finalCta: {
      title: 'Tu CV profesional te espera',
      subtitle: 'Únete a miles de personas que ya crearon su CV con CVtoday.',
      cta: 'Empezar ahora — es gratis',
    },
    footer: {
      tagline: 'Crea tu CV profesional en minutos.',
      product: 'Producto',
      builder: 'Editor de CV',
      templates: 'Plantillas',
      aiReview: 'Revisión con IA',
      resources: 'Recursos',
      blog: 'Blog',
      guide: 'Guía de CV',
      examples: 'Ejemplos',
      legal: 'Legal',
      privacy: 'Privacidad',
      terms: 'Términos',
      copyright: 'CVtoday. Todos los derechos reservados.',
    },
  },

  cvLimit: {
    title: 'Crea tu cuenta para seguir',
    description: 'CVtoday es y sera gratis. Solo necesitamos tu registro para guardar tus CVs de forma segura y que no los pierdas.',
  },

  privacy: {
    title: 'Politica de Privacidad',
    lastUpdated: 'Ultima actualizacion: 8 de febrero de 2026',
    intro: 'En CVtoday nos tomamos tu privacidad en serio. Esta politica describe que datos recopilamos, como los usamos y tus derechos sobre ellos.',
    dataWeCollectTitle: 'Datos que recopilamos',
    dataWeCollectLocal: 'Datos del CV almacenados localmente: Tu CV se guarda en el almacenamiento local de tu navegador (localStorage). Estos datos nunca salen de tu dispositivo a menos que decidas crear una cuenta, publicar tu CV o usar funciones de IA (importacion o revision).',
    dataWeCollectAuth: 'Datos de autenticacion: Si creas una cuenta, recopilamos tu nombre, direccion de correo electronico y metodo de autenticacion (email/contrasena o Google OAuth).',
    dataWeCollectFirestore: 'Datos en la nube: Si inicias sesion, tus CVs se sincronizan con Firebase Firestore para que puedas acceder a ellos desde cualquier dispositivo. Los CVs publicados se almacenan publicamente bajo el slug que elijas.',
    howWeUseTitle: 'Como usamos tus datos',
    howWeUsePdf: 'Generacion de PDF: Los datos de tu CV se procesan en tu navegador para generar documentos PDF. Ningun dato se envia a nuestros servidores para este proceso.',
    howWeUseAi: 'Revision con IA: Si usas la funcion de revision con IA, el contenido de tu CV se envia a la API de Anthropic Claude para su analisis. Anthropic no utiliza estos datos para entrenamiento.',
    howWeUseImport: 'Importacion de PDF: Al importar un CV desde un PDF, el texto extraido se envia a nuestro servidor (Cloud Function) que lo procesa con la API de Anthropic Claude para extraer los datos estructurados. El resultado de la extraccion se almacena en nuestra base de datos (Firestore) con fines de auditoria y mejora del servicio.',
    howWeUseSync: 'Sincronizacion en la nube: Si tienes una cuenta, tus CVs se sincronizan con Firebase para respaldo y acceso multi-dispositivo.',
    thirdPartyTitle: 'Servicios de terceros',
    thirdPartyFirebase: 'Firebase (Google): Autenticacion de usuarios, almacenamiento en la nube (Firestore) y hosting. Sujeto a la politica de privacidad de Google.',
    thirdPartyClaude: 'Anthropic Claude API: Utilizada para la revision de CV con IA y la extraccion de datos de PDF. Los datos no se utilizan para entrenamiento del modelo.',
    thirdPartyKofi: 'Ko-fi: Si eliges apoyarnos, seras redirigido a Ko-fi para procesar la donacion. CVtoday no recopila informacion de pago.',
    cookiesTitle: 'Cookies y almacenamiento local',
    cookiesDesc: 'CVtoday no utiliza cookies de seguimiento ni de publicidad. Utilizamos localStorage del navegador para guardar tus datos del CV y preferencias (como el idioma). Firebase puede establecer cookies tecnicas necesarias para la autenticacion.',
    retentionTitle: 'Retencion y eliminacion de datos',
    retentionDesc: 'Los datos locales se pueden eliminar borrando los datos del navegador. Los datos en la nube se pueden eliminar desde tu cuenta o contactandonos en info@cv-today.com. Los CVs publicados se pueden despublicar en cualquier momento desde el editor.',
    contactTitle: 'Contacto',
    contactDesc: 'Si tienes preguntas sobre esta politica de privacidad, contactanos en info@cv-today.com.',
  },

  terms: {
    title: 'Terminos de Servicio',
    lastUpdated: 'Ultima actualizacion: 8 de febrero de 2026',
    acceptanceTitle: 'Aceptacion de los terminos',
    acceptanceDesc: 'Al acceder y utilizar CVtoday (cv-today.com), aceptas estos terminos de servicio. Si no estas de acuerdo con alguno de estos terminos, no utilices el servicio.',
    serviceTitle: 'Descripcion del servicio',
    serviceDesc: 'CVtoday es una aplicacion web que permite crear, editar y descargar curriculums vitae (CVs) en formato PDF. El servicio incluye edicion en tiempo real, multiples plantillas, revision con IA y publicacion de CVs en linea.',
    accountsTitle: 'Cuentas de usuario',
    accountsDesc: 'Puedes usar CVtoday sin crear una cuenta. Las funciones basicas (crear y descargar CVs) estan disponibles sin registro. Crear una cuenta te permite sincronizar tus CVs en la nube, publicar CVs en linea y acceder a funciones adicionales. Eres responsable de mantener la seguridad de tu cuenta.',
    contentTitle: 'Propiedad del contenido',
    contentDesc: 'Todo el contenido que creas en CVtoday (datos del CV, textos, fotos) te pertenece. CVtoday no reclama ningun derecho de propiedad sobre tu contenido. Al publicar un CV, otorgas a CVtoday permiso para mostrarlo publicamente en la URL que elijas.',
    acceptableUseTitle: 'Uso aceptable',
    acceptableUseDesc: 'Te comprometes a utilizar CVtoday unicamente con fines legales y legitimos. No debes: intentar acceder sin autorizacion a otros usuarios o sistemas, usar el servicio para distribuir contenido ilegal o danino, intentar interferir con el funcionamiento del servicio, ni usar herramientas automatizadas para acceder al servicio de forma masiva.',
    liabilityTitle: 'Limitacion de responsabilidad',
    liabilityDesc: 'CVtoday se proporciona "tal cual" sin garantias de ningun tipo. No nos responsabilizamos de danos directos, indirectos o consecuentes derivados del uso del servicio. No garantizamos que el servicio este disponible de forma ininterrumpida ni libre de errores. Las revisiones de IA son sugerencias y no constituyen asesoramiento profesional.',
    changesTitle: 'Cambios en los terminos',
    changesDesc: 'Nos reservamos el derecho de modificar estos terminos en cualquier momento. Los cambios se publicaran en esta pagina con la fecha de actualizacion. El uso continuado del servicio despues de los cambios constituye tu aceptacion de los nuevos terminos.',
    contactTitle: 'Contacto',
    contactDesc: 'Si tienes preguntas sobre estos terminos de servicio, contactanos en info@cv-today.com.',
  },

  downloadModal: {
    preparing: 'Preparando tu CV...',
    ready: 'Tu CV esta listo!',
    supportTitle: 'CVtoday es mayoritariamente gratis',
    supportMessage: 'Si te resulto util, considera apoyarnos con un cafe. Cada aporte nos ayuda a seguir mejorando.',
    supportButton: 'Invitanos un cafe',
  },

  publish: {
    sharePublicLink: 'Comparte tu CV con un link publico',
    cvUrl: 'URL de tu CV',
    checking: 'Verificando disponibilidad...',
    available: 'Disponible',
    unavailable: 'No disponible, elige otro',
    copyLink: 'Copiar link',
    views: 'visitas',
    publishCV: 'Publicar CV',
    update: 'Actualizar',
    unpublish: 'Despublicar',
    registerToPublish: 'Registrate para publicar',
    needAccountToPublish: 'Necesitas una cuenta para publicar tu CV',
    published: 'CV publicado',
    updated: 'CV actualizado',
    unpublished: 'CV despublicado',
    shareMessage: 'Mira mi CV:',
    loginToPublish: 'Debes iniciar sesion para publicar',
    publishError: 'Error al publicar',
    updateError: 'Error al actualizar',
    unpublishError: 'Error al despublicar',
  },
}
